export const CATEGORIES = [
  { id: 'all', name: 'All' },
  { id: 'react', name: 'React JS' },
  { id: 'javascript', name: 'JavaScript' },
  { id: 'web', name: 'Web Development' },
  { id: 'tutorial', name: 'Tutorial' },
  { id: 'database', name: 'Database' }
];
